import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const ProtectedRoute = ({ element: Component, requiredGroup }) => {
  const { user } = useAuth();

  // Check if user has the required group
  const hasRequiredGroup = user?.groups?.includes(requiredGroup);

  // If user has no groups or doesn't have the required group, redirect to home
  if (!user?.groups || !hasRequiredGroup) {
    return <Navigate to="/" replace />;
  }

  return Component;
};

export default ProtectedRoute;
